// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatasyrupusdt } from "../../../icons/full/build/icon-statasyrupusdt.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatasyrupusdtIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatasyrupusdt.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatasyrupusdtIcon.displayName = 'StatasyrupusdtIcon';
}

export default StatasyrupusdtIcon;